import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import label from "../labels/common_en.json";
import Select from "react-select";
import {
  getUserRoles,
  getUsersByRoleIdFrom,
  getUsersByRoleIdTo,
  getAllModules,
  getSubModulesByModuleId,
  manageUserAccess,
  getAssignedSubModulesByUserModuleId,
  getFlagAccessStatus,
  getUserRolesByDept,
  getModuleSubModule,
  getUserUpdateDataId,
} from "../actions/commonActions";
import { getDepartment } from "../../../src/login/actions/loginAction";
import { set } from "lodash";
import { SET_MODULE_SUBMODULE } from "../constants/ActionTypes";
// import CheckboxTree from 'react-checkbox-tree';
// import 'font-awesome/css/font-awesome.min.css';

function AssignAccessToRoleOrUser() {
  const { register, handleSubmit, errors, reset } = useForm({
    mode: "onChange",
  });

  let {
    userRolesList,
    getUserDeptRoles,
    userListByRoleIdTo,
    getUserDeptRolesFrom,
    allModulesList,
    allSubModulesList,
    allAssignedSubModulesList,
    getAccessStatus,
    allDepartments,
    getModuleSubmodule,
    getUpdateUserData,
  } = useSelector((state) => state.common, shallowEqual);


  const [checked, setChecked] = useState([]);
  const [expanded, setExpanded] = useState([]);

  const [selectedRoleFrom, setSelectedRoleFrom] = useState("");
  const [selectedRoleTo, setSelectedRoleTo] = useState("");
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [reloadItem, setReloadItem] = useState(true);
  const [selectedType, setSelectedType] = useState("");
  const [module, setModule] = useState([]);
  const [allTypes, setAllTypes] = useState([
    { id: 1, name: label.AssignUserToModule },
    { id: 2, name: label.AssignUserToUser },
  ]);

  const [selectedUserFrom, setSelectedUserFrom] = useState("");
  const [selectedUserTo, setSelectedUserTo] = useState("");
  const [selectedModule, setSelectedModule] = useState("");
  const [selectSubData, setSelectSubData] = useState([]);
  const [options, setOptions] = useState([]);
  const [selectCheck, setSelectCheck] = useState([]);
  const [selectSubModuleOption, setSelectSubModuleOption] = useState([]);
  const [allCheckedBox, setAllCheckedBox] = useState([]);
  const [flgAccess, setFlgAccess] = useState(false);
  const [roleToList, setRoleToList] = useState([]);
  const [flgAccessStatus, setFlgAccessStatus] = useState(false);
  const [deparmentList, setDeparmentList] = useState("");
  const [deparmentActive, setDeparmentActive] = useState(false);
  const [roleActive, setRoleActive] = useState(false);
  const [subModule, setSetModule] = useState(false);
  const [subModuleArray, setSubModuleArray] = useState([]);
  const [uncheckedArray, setUncheckedArray] = useState([]);
  const [allChecked, setAllChecked] = useState(false);
  const [checkedStates, setCheckedStates] = useState([]);
  const [allData, setAllData] = useState([]);
  const [check, setCheck] = useState("");
  const [showModule, setShowModule] = useState(false);
  const [UpdatedValue, setUpdatedValue] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => { }, [reloadItem]);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getDepartment());
    onCancelButton();
    setReloadItem(!reloadItem);
    dispatch({
      payload: [],
      type: SET_MODULE_SUBMODULE,
    });
    setSubModuleArray([]);
    setAllData([]);
    setShowModule(false);
    setUpdatedValue([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (getUpdateUserData && getUpdateUserData.moduleAccess && getUpdateUserData.moduleAccess.flgModuleAccess !== undefined) {
      setFlgAccessStatus(getUpdateUserData.moduleAccess.flgModuleAccess);
    }
  }, [getUpdateUserData]);

  // useEffect(() => {
  //   setModule(getModuleSubmodule?.moduleDtos);
  // }, []);
  useEffect(() => {
    allSubModulesList &&
      allSubModulesList.length > 0 &&
      allSubModulesList.map((element, index) => {
        let opt = { value: element.id, label: element.name };
        setOptions((arr) => [...arr, opt]);
        setAllCheckedBox((arr) => [...arr, "checked"]);
      });
  }, [allSubModulesList]);

  useEffect(() => {
    if (selectedUserFrom) {
      setRoleToList(userRolesList);
    }
  }, [selectedUserFrom, userRolesList]);

  useEffect(() => {

    const updatedSubModuleArray = subModuleArray.map((module) => {
      const updatedSubModules = module.subModules.filter(
        (subModule) =>
          subModule.create !== false ||
          subModule.update !== false ||
          subModule.read !== false ||
          subModule.delete !== false
      );


      return {
        ...module,
        subModules: updatedSubModules,
      };
    });

    setAllData(updatedSubModuleArray);
  }, [subModuleArray]);


  useEffect(() => {
    if (
      getUpdateUserData &&
      getUpdateUserData?.moduleAccess &&
      getUpdateUserData?.moduleAccess.accessData.length > 0
    ) {
      const Value = getUpdateUserData?.moduleAccess?.accessData.map(
        (item, index) => item
      );

      setUpdatedValue(Value)
    }
  }, [getUpdateUserData?.moduleAccess?.accessData]);


  useEffect(() => {
    setSelectedRoleFrom("");
    setSelectedRoleTo("");
    setSelectedUserFrom("");
    setSelectedUserTo("");
    setSelectedModule("");
    setDeparmentList("");
    setFlgAccess(false);
    setFlgAccessStatus(false);
    setDeparmentActive(false);
    setRoleActive(false);
    // getUserDeptRoles.length = 0;
    // getUserDeptRolesFrom.length = 0;
    // userListByRoleIdTo.length = 0;
    // allSubModulesList.length = 0;
    // allAssignedSubModulesList.length = 0;
    setSaveButtonFlag(true);
    setAllCheckedBox([]);
    setSelectCheck([]);
    setReloadItem(!reloadItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedType]);

  const onTypeChange = (ele) => {
    let selType = ele;
    setSelectedType(selType);
    setAllData([]);
    setReloadItem(!reloadItem);
    dispatch(getModuleSubModule());
    setFlgAccessStatus(false);
  };

  const convertArrayToObj = (dataArray) => {
    // Initialize an empty object to store the merged data
    const mergedObject = {};
    // Iterate through the array and merge each object into the mergedObject
    dataArray.forEach((obj) => {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          mergedObject[key] = obj[key];
        }
      }
    });
    return mergedObject;
  };

  const onSubmit = () => {
    let data = {};
    if (selectedType == 1) {
      data = {
        roleId: selectedRoleFrom,
        accessUserId: selectedUserFrom,
        accessData: allData,
        flgModuleAccess: flgAccessStatus,
      };
    } else if (selectedType == 2) {
      data = {
        roleId: selectedRoleFrom,
        userId: selectedUserFrom,
        accessUserId: selectedUserTo,
        flgUserAccess: flgAccessStatus,
      };
    }

    dispatch(manageUserAccess(data, selectedUserFrom));
    reset();

    onCancelButton();
  };

  const onCancelButton = () => {
    setSelectedType("");
    setSelectedRoleFrom("");
    setSelectedRoleTo("");
    setSelectedUserFrom("");
    setSelectedUserTo("");
    setSelectedModule("");
    setDeparmentList("");
    setFlgAccess(false);
    setFlgAccessStatus(false);
    setDeparmentActive(false);
    setRoleActive(false);
    setAllData([]);
    // getUserDeptRoles.length = 0;
    // getUserDeptRolesFrom.length = 0;
    // userListByRoleIdTo.length = 0;
    // allSubModulesList.length = 0;
    // allAssignedSubModulesList.length = 0;
    setSaveButtonFlag(true);
    setAllCheckedBox([]);
    setSelectCheck([]);
    setUpdatedValue([]);
    setReloadItem(!reloadItem);
    reset();
  };

  const onRoleFromChange = (e) => {
    let selectedValue = e;
    selectedValue &&
      dispatch(getUserRolesByDept(deparmentList, selectedValue, 0));
    setSelectedRoleFrom(selectedValue);
    setRoleToList([]);
    setReloadItem(!reloadItem);
    // getUserDeptRoles?.length = 0;
    // getUserDeptRolesFrom?.length = 0;
    // userListByRoleIdTo?.length = 0;
    // allModulesList?.length = 0;
    // allSubModulesList?.length = 0;
    setFlgAccessStatus(false);
    // userRolesList.length=0;
  };

  const onRoleToChange = (e) => {
    let selectedValue = e;
    userListByRoleIdTo.length = 0;
    selectedValue &&
      dispatch(getUserRolesByDept(deparmentList, selectedValue, 1));
    setSelectedRoleTo(selectedValue);
    setFlgAccessStatus(false);
    setReloadItem(!reloadItem);
  };

  const onUserFromChange = (e) => {
    let selectedValue = e;
    setSelectedUserFrom(selectedValue);
    setRoleToList([]);
    setUpdatedValue([]);
    setAllCheckedBox([]);
    setSelectCheck([]);
    setAllData([]);
    setSubModuleArray([]);
    setFlgAccessStatus(false);
    // userListByRoleIdTo?.length = 0;
    // allModulesList?.length = 0;
    // allSubModulesList?.length = 0;
    // selectedValue &&
    //   dispatch(getFlagAccessStatus(selectedValue, setFlgAccessStatus))
    setShowModule(true);
    // setFlgAccessStatus(false);
    selectedValue && dispatch(getAllModules());
    selectedValue && dispatch(getUserUpdateDataId(selectedValue));
    setReloadItem(!reloadItem);
  };

  const onUserToChange = (e) => {
    let selectedValue = e;
    setSelectedUserTo(selectedValue);
    setFlgAccessStatus(false);
    // selectedValue &&
    //   dispatch(getFlagAccessStatus(selectedValue, setFlgAccessStatus));
    // getAccessStatus && setFlgAccessStatus(getAccessStatus);
    setReloadItem(!reloadItem);
    setSaveButtonFlag(false);
  };

  const onModuleChange = (e) => {
    let selectedValue = e;
    setSelectedModule(selectedValue);
    if (allSubModulesList) {
      allSubModulesList.length = 0;
    }
    setSelectSubModuleOption([]);
    if (selectedValue) {
      dispatch(getSubModulesByModuleId(selectedValue, selectedUserFrom));
      // dispatch(
      //   getAssignedSubModulesByUserModuleId(selectedUserFrom, selectedValue)
      // );
    }

    setReloadItem(!reloadItem);
  };

  // const updateSubModule = (
  //   eleIndexArray,
  //   eleName,
  //   eleVal,
  //   allcheck,
  //   eleindex
  // ) => {
  //   const subModules = {};
  //   let arr = [];
  //   let exist = false;
  //   selectSubModuleOption &&
  //     selectSubModuleOption.length > 0 &&
  //     selectSubModuleOption.map((ele, ind) => {
  //       if (ele[eleName] !== undefined) {
  //         exist = true;
  //       }
  //     });

  //   if (exist) {
  //     let newArray = selectSubModuleOption;
  //     selectSubModuleOption &&
  //       selectSubModuleOption.length > 0 &&
  //       selectSubModuleOption.map((elem, index) => {
  //         if (eleVal == "All") {
  //           arr = ["C", "R", "U", "D"];
  //           newArray[index][eleName] = arr;
  //         } else {
  //           if (newArray[index][eleName]) {
  //             // newArray[index][eleName].push(eleVal);
  //             newArray = newArray.map((item, idx) => idx === index ? { ...item, [eleName]: [...item[eleName], eleVal] } : item);
  //           }
  //         }
  //         setSelectSubModuleOption(newArray);
  //         setReloadItem(!reloadItem);
  //       });
  //   } else {
  //     if (eleVal == "All") {
  //       arr = ["C", "R", "U", "D"];
  //       subModules[eleName] = arr;
  //     } else {
  //       subModules[eleName] = [eleVal];
  //     }

  //     setSelectSubModuleOption((arr) => [...arr, subModules]);
  //     setReloadItem(!reloadItem);
  //   }

  //   let existOrNot = false;
  //   let oldValues = selectCheck;
  //   let oldCheckBoxes = allCheckedBox;
  //   eleIndexArray &&
  //     eleIndexArray.length > 0 &&
  //     eleIndexArray.map((elIndex, ind) => {
  //       if (eleIndexArray.length > 1) {
  //         if (allcheck == "checked") {
  //           // oldCheckBoxes[ind] = "unchecked";
  //           oldCheckBoxes = oldCheckBoxes.map((item, idx) => idx === ind ? "unchecked" : item);
  //           setSelectCheck((arr) => [...arr, elIndex]);
  //           setAllCheckedBox(oldCheckBoxes);
  //           setReloadItem(!reloadItem);
  //         } else {
  //           const updatedValues =
  //             oldValues &&
  //             oldValues.length > 0 &&
  //             oldValues.filter((value) => value !== elIndex);
  //           oldCheckBoxes[ind] = "checked";
  //           oldValues = updatedValues;

  //           setSelectCheck(updatedValues);
  //           setAllCheckedBox(oldCheckBoxes);
  //           setReloadItem(!reloadItem);
  //         }
  //       } else {
  //         existOrNot =
  //           oldValues &&
  //           oldValues.length > 0 &&
  //           oldValues.find((ele) => ele == elIndex);
  //         if (!existOrNot) {
  //           setSelectCheck((arr) => [...arr, elIndex]);
  //           setReloadItem(!reloadItem);
  //         } else {
  //           const updatedValues =
  //             oldValues &&
  //             oldValues.length > 0 &&
  //             oldValues.filter((value) => value !== elIndex);

  //           oldValues = updatedValues;
  //           setSelectCheck(updatedValues);
  //           setReloadItem(!reloadItem);
  //         }
  //       }
  //     });

  //   setSaveButtonFlag(false);
  // };

  // const updateSubModule = (
  //   eleIndexArray,
  //   eleName,
  //   eleVal,
  //   allcheck,
  //   eleindex
  // ) => {
  //   const subModules = {};
  //   let arr = [];
  //   let exist = false;

  //   selectSubModuleOption &&
  //     selectSubModuleOption.length > 0 &&
  //     selectSubModuleOption.forEach((ele, ind) => {
  //       if (ele[eleName] !== undefined) {
  //         exist = true;
  //       }
  //     });

  //   if (exist) {
  //     let newArray = selectSubModuleOption.map((item) => ({ ...item }));
  //     selectSubModuleOption &&
  //       selectSubModuleOption.length > 0 &&
  //       selectSubModuleOption.forEach((elem, index) => {
  //         if (eleVal === "All") {
  //           arr = ["C", "R", "U", "D"];
  //           newArray[index][eleName] = arr;
  //         } else {
  //           if (newArray[index][eleName]) {
  //             newArray = newArray.map((item, idx) =>
  //               idx === index
  //                 ? { ...item, [eleName]: [...item[eleName], eleVal] }
  //                 : item
  //             );
  //           }
  //         }
  //       });
  //     setSelectSubModuleOption(newArray);
  //     setReloadItem(!reloadItem);
  //   } else {
  //     if (eleVal === "All") {
  //       arr = ["C", "R", "U", "D"];
  //       subModules[eleName] = arr;
  //     } else {
  //       subModules[eleName] = [eleVal];
  //     }

  //     setSelectSubModuleOption((arr) => [...arr, subModules]);
  //     setReloadItem(!reloadItem);
  //   }

  //   let existOrNot = false;
  //   let oldValues = selectCheck.map((item) => item);
  //   let oldCheckBoxes = allCheckedBox.map((item) => item);

  //   eleIndexArray &&
  //     eleIndexArray.length > 0 &&
  //     eleIndexArray.forEach((elIndex, ind) => {
  //       if (eleIndexArray.length > 1) {
  //         if (allcheck === "checked") {
  //           oldCheckBoxes = oldCheckBoxes.map((item, idx) =>
  //             idx === ind ? "unchecked" : item
  //           );
  //           setSelectCheck((arr) => [...arr, elIndex]);
  //           setAllCheckedBox(oldCheckBoxes);
  //           setReloadItem(!reloadItem);
  //         } else {
  //           const updatedValues = oldValues.filter(
  //             (value) => value !== elIndex
  //           );
  //           oldCheckBoxes[ind] = "checked";
  //           oldValues = updatedValues;

  //           setSelectCheck(updatedValues);
  //           setAllCheckedBox(oldCheckBoxes);
  //           setReloadItem(!reloadItem);
  //         }
  //       } else {
  //         existOrNot = oldValues.find((ele) => ele === elIndex);
  //         if (!existOrNot) {
  //           setSelectCheck((arr) => [...arr, elIndex]);
  //           setReloadItem(!reloadItem);
  //         } else {
  //           const updatedValues = oldValues.filter(
  //             (value) => value !== elIndex
  //           );

  //           oldValues = updatedValues;
  //           setSelectCheck(updatedValues);
  //           setReloadItem(!reloadItem);
  //         }
  //       }
  //     });

  //   setSaveButtonFlag(false);
  // };

  // useEffect(() => {
  //   const initialCheckedStates = {};
  //   subModuleArray.forEach((item) => {
  //     initialCheckedStates[item.id] = {};
  //     item.subModules.forEach((subItem) => {
  //       initialCheckedStates[item.id][subItem.id] = false;
  //     });
  //   });
  //   setAllChecked(initialCheckedStates);
  // }, [subModuleArray]);

  const setAllCheckboxesChecked = (isChecked) => {
    setAllChecked(isChecked);
  };

  const handleChangeDepartment = (e) => {
    let selectedValue = e.target.value;
    setDeparmentList(selectedValue);
    dispatch(getUserRoles());
  };
  useEffect(() => {
    setSubModuleArray(UpdatedValue);
  }, [UpdatedValue]);
  const oncheckModule = (moduleId, isChecked) => {


    const validModule = getModuleSubmodule.find((item) => item.id === moduleId);


    // Add default values for read, create, update, and delete
    const defaultSubModules = validModule.subModules.map((subModule) => ({
      ...subModule,
      read: false,
      create: false,
      update: false,
      delete: false,
    }));

    if (isChecked) {
      setSubModuleArray((prevArray) => [
        ...prevArray,
        { ...validModule, subModules: defaultSubModules },
      ]);
    } else {
      setSubModuleArray((prevArray) =>
        prevArray.filter((item) => item.id !== moduleId)
      );
    }

    setCheck(isChecked);
    setSetModule(true);
  };

  const updateSubModule = (itemID, index, val, type) => {
    setSaveButtonFlag(false);

    const updatedSubModuleArray = subModuleArray.map((module) => {
      if (module.id === itemID) {
        const updatedSubModules = module.subModules.map((subModule) => {
          if (subModule.id === index && type === "SelectALL") {
            return {
              ...subModule,
              read: val,
              create: val,
              update: val,
              delete: val,
            };
          } else if (subModule.id === index && type === "create") {
            return {
              ...subModule,
              create: val,
              read: subModule.read, // Keep the existing read value
              update: subModule.update, // Keep the existing update value
              delete: subModule.delete, // Keep the existing delete value
            };
          } else if (subModule.id === index && type === "read") {
            return {
              ...subModule,
              create: subModule.create,
              read: val, // Keep the existing read value
              update: subModule.update, // Keep the existing update value
              delete: subModule.delete, // Keep the existing delete value
            };
          } else if (subModule.id === index && type === "update") {
            return {
              ...subModule,
              create: subModule.create,
              read: subModule.read, // Keep the existing read value
              update: val, // Keep the existing update value
              delete: subModule.delete, // Keep the existing delete value
            };
          } else if (subModule.id === index && type === "delete") {
            return {
              ...subModule,
              create: subModule.create,
              read: subModule.read, // Keep the existing read value
              update: subModule.update, // Keep the existing update value
              delete: val, // Keep the existing delete value
            };
          } else {
            return subModule;
          }
        });

        return {
          ...module,
          subModules: updatedSubModules,
        };
      } else {
        return module;
      }
    });

    setSubModuleArray(updatedSubModuleArray);
  };

  // const updateSelectCheck = (subModules) => {
  //   let updatedSelectCheck = [];
  //   Object.keys(subModules).forEach((key, index) => {

  //     subModules[key].forEach((value) => {
  //       updatedSelectCheck.push(`${index + 1}_${value}`);
  //     });
  //   });
  //   setSelectCheck(updatedSelectCheck);
  // };

  // useEffect(() => {
  //   if (allAssignedSubModulesList && allAssignedSubModulesList.subModules) {
  //     updateSelectCheck(allAssignedSubModulesList.subModules);
  //   }
  // }, [allAssignedSubModulesList]);

  // const updateSelectCheck = (subModules, allSubModulesList) => {
  //   let updatedSelectCheck = [];
  //   allSubModulesList && allSubModulesList.forEach((element) => {
  //     if (subModules[element.name]) {
  //       subModules[element.name].forEach((value) => {
  //         updatedSelectCheck.push(`${element.id}_${value}`);
  //       });
  //     }
  //   });
  //   setSelectCheck(updatedSelectCheck);
  // };

  // useEffect(() => {
  //   if (allAssignedSubModulesList && allAssignedSubModulesList.subModules) {
  //     updateSelectCheck(allAssignedSubModulesList.subModules, allSubModulesList);
  //   }
  // }, [allAssignedSubModulesList, allSubModulesList]);

  // Convert your modules and submodules to the format required by react-checkbox-tree
  // const nodes = allModulesList.map(module => ({
  //   value: 4,
  //   label: module.name,
  //   children: allSubModulesList.map(submodule => ({
  //     value: 4,
  //     label: "test"
  //   }))
  // }));

  return (
    <div className="dashboardContentArea">
      <h5> {label.AssignUserAccess} </h5>

      <div className="row dashboardCards">
        <div className="col-md-12">
          <form name="importForm" encType="multipart/form-data">
            <div className="form-group importFromSection">
              <div className="row">
                <div className="form-group col-md-4">
                  <label className="float-left">
                    {label.SelectType}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedTypes"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onTypeChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {label.COMBO_SELECT}
                    </option>
                    {allTypes &&
                      allTypes.length > 0 &&
                      allTypes.map((element, index) => (
                        <option key={index} value={element.id}>
                          {element.name}
                        </option>
                      ))}
                  </select>
                  {_.get("selectedTypes.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {label.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
              </div>
              {selectedType == 1 && (
                <>
                  <div className="row">
                    <div className="form-group col-md-3">
                      <label className="float-left">
                        {label.DEPARTMENT}
                        <span className="errorText">*</span>
                      </label>
                      <div className="input-group">
                        <select
                          className="form-control"
                          name="department"
                          onChange={handleChangeDepartment}
                          ref={register({ required: true })}
                        >
                          <option key="" value="">
                            Select
                          </option>
                          {allDepartments.map((ele, i) => {
                            return (
                              <option key={i} value={ele.id}>
                                {ele.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      {_.get("department.type", errors) === "required" && (
                        <p className="errorText">
                          {label.MANDATORY_FIELD_MESSAGE}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-3">
                      <label className="float-left">
                        {label.SelectRoleFrom}
                        <span className="errorText">*</span>
                      </label>
                      <select
                        className="form-control"
                        name="selectedRoleFrom"
                        disabled={deparmentList ? false : true}
                        ref={register({ required: true })}
                        onChange={(e) => {
                          onRoleFromChange(e.target.value);
                        }}
                      >
                        <option key={0} value="">
                          {label.COMBO_SELECT}
                        </option>
                        {userRolesList &&
                          userRolesList.length > 0 &&
                          userRolesList.map((element, index) => (
                            <option key={index} value={element.id}>
                              {element.name}
                            </option>
                          ))}
                      </select>
                      {_.get("selectedRoleFrom.type", errors) ===
                        "required" && (
                          <p className="errorText float-left">
                            {label.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                    </div>
                    <div className="form-group col-md-3">
                      <label className="float-left">
                        {label.SelectUserFrom}
                        <span className="errorText">*</span>
                      </label>
                      <select
                        className="form-control"
                        name="selectedUserFrom"
                        disabled={selectedRoleFrom ? false : true}
                        ref={register({ required: true })}
                        onChange={(e) => {
                          onUserFromChange(e.target.value);
                        }}
                      >
                        <option key={0} value="">
                          {label.COMBO_SELECT}
                        </option>
                        {getUserDeptRoles &&
                          getUserDeptRoles.length > 0 &&
                          getUserDeptRoles.map((element, index) => (
                            <option key={index} value={element.id}>
                              {element.firstName} {element.lastName}
                            </option>
                          ))}
                      </select>
                      {_.get("selectedUserFrom.type", errors) ===
                        "required" && (
                          <p className="errorText float-left">
                            {label.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                    </div>
                  </div>

                  {showModule &&
                    getModuleSubmodule &&
                    getModuleSubmodule.length > 0 && (
                      <div className="row">
                        <div className="col-md-3 modules">
                          <label className="float-left">
                            {label.SelectModule}
                            <span className="errorText">*</span>
                          </label>
                          {getModuleSubmodule &&
                            getModuleSubmodule.map((item, index) => {
                              return (<div key={index} className="p-1">
                                <input
                                  type="checkbox"
                                  onChange={(e) =>
                                    oncheckModule(item.id, e.target.checked)
                                  }
                                  name="module[]"
                                  defaultChecked={UpdatedValue.find((itm) => itm.id == item.id)}
                                />
                                <label className="ml-2">{item.name}</label>
                                {subModuleArray &&
                                  subModuleArray.length > 0 &&
                                  subModuleArray.map((subItem, subIndex) => {
                                    if (
                                      (subItem.id === item.id &&
                                        subItem.subModules &&
                                        subItem.subModules?.length > 0)
                                    ) {
                                      return (
                                        <div className="row" key={subIndex}>
                                          <div className="form-group col-md-6">
                                            <table className="table table-bordered">
                                              <thead className="thead-light">
                                                <tr>
                                                  <th scope="col w-50">
                                                    {label.SubModuleName}
                                                  </th>
                                                  <th
                                                    className="text-center"
                                                    scope="col w-30"
                                                  >
                                                    {label.AllSelect}
                                                  </th>
                                                  <th scope="col w-5">
                                                    {label.Create}
                                                  </th>
                                                  <th scope="col w-5">
                                                    {label.Read}
                                                  </th>
                                                  <th scope="col w-5">
                                                    {label.Update}
                                                  </th>
                                                  <th scope="col w-5">
                                                    {label.Delete}
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody  className="small"
                                              >
                                                {subItem.subModules &&
                                                  subItem.subModules.map(
                                                    (element, eleindex) => {
                                                      return (
                                                        <tr key={eleindex}>
                                                          <td>
                                                            {element.name}
                                                          </td>
                                                          <td className="d-flex justify-content-center align-items-center">
                                                            <input
                                                              type="checkbox"
                                                              defaultChecked={element.create && element.read && element.delete && element.update}
                                                              onChange={(e) =>
                                                                updateSubModule(
                                                                  item.id,
                                                                  element.id,
                                                                  e.target
                                                                    .checked,
                                                                  "SelectALL"
                                                                )
                                                              }
                                                            />
                                                          </td>
                                                          <td>
                                                            <input
                                                              type="checkbox"
                                                              checked={
                                                                element.create
                                                              }
                                                              onChange={(e) =>
                                                                updateSubModule(
                                                                  item.id,
                                                                  element.id,
                                                                  e.target
                                                                    .checked,
                                                                  "create"
                                                                )
                                                              }
                                                            />
                                                          </td>
                                                          <td>
                                                            <input
                                                              type="checkbox"
                                                              checked={
                                                                element.read
                                                              }
                                                              onChange={(e) =>
                                                                updateSubModule(
                                                                  item.id,
                                                                  element.id,
                                                                  e.target
                                                                    .checked,
                                                                  "read"
                                                                )
                                                              }
                                                            />
                                                          </td>
                                                          <td>
                                                            <input
                                                              type="checkbox"
                                                              checked={
                                                                element.update
                                                              }
                                                              onChange={(e) =>
                                                                updateSubModule(
                                                                  item.id,
                                                                  element.id,
                                                                  e.target
                                                                    .checked,
                                                                  "update"
                                                                )
                                                              }
                                                            />
                                                          </td>
                                                          <td>
                                                            <input
                                                              type="checkbox"
                                                              checked={
                                                                element.delete
                                                              }
                                                              onChange={(e) =>
                                                                updateSubModule(
                                                                  item.id,
                                                                  element.id,
                                                                  e.target
                                                                    .checked,
                                                                  "delete"
                                                                )
                                                              }
                                                            />
                                                          </td>
                                                        </tr>
                                                      );
                                                    }
                                                  )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      );
                                    }
                                  })}
                              </div>)
                            })}

                          {/* <select
                        className="form-control"
                        name="selectedModule"
                        disabled={selectedUserFrom ? false : true}
                        ref={register({ required: true })}
                        onChange={(e) => {
                          onModuleChange(e.target.value);
                        }}
                      >
                        <option key={0} value="">
                          {label.COMBO_SELECT}
                        </option>
                        {allModulesList &&
                          allModulesList.length > 0 &&
                          allModulesList.map((element, index) => (
                            <option key={index} value={element.id}>
                              {element.name}
                            </option>
                          ))}
                      </select>
                      {_.get("selectedModule.type", errors) === "required" && (
                        <p className="errorText float-left">
                          {label.MANDATORY_FIELD_MESSAGE}
                        </p>
                      )} */}
                        </div>
                      </div>
                    )}
                  <div className="row">
                    <div
                    className="form-group col-md-3 bg-light p-3 rounded"
                    >
                      <label className="float-left">{label.GiveAccess}</label>
                      <br />
                      <div className="custom-control custom-switch">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          // defaultChecked={flgAccessStatus}
                          checked={flgAccessStatus}
                          id="customSwitch1"
                          name="flgAccess"
                          onChange={(e) => {
                            setFlgAccessStatus(e.target.checked);
                          }}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customSwitch1"
                        >
                          {flgAccessStatus
                            ? "access given"
                            : "access not given"}
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* <div className="form-group col-md-3">
                    <label className="float-left">
                      {label.SelectModule}
                      <span className="errorText">*</span>
                    </label><br />
                    <CheckboxTree
                      iconsClass="fa4"
                      nodes={nodes}
                      checked={checked}
                      expanded={expanded}
                      onCheck={checked => setChecked(checked)}
                      onExpand={expanded => setExpanded(expanded)}
                    />
                  </div> */}

                  {/* {allSubModulesList && allSubModulesList.length > 0 && (
                    <div className="row">
                      <div className="form-group col-md-6">
                        <label className="float-left">
                          {label.SelectSubModule}
                          <span className="errorText">*</span>
                        </label>
                        
                        <table className="table table-bordered">
                          <thead className="thead-light">
                            <tr>
                              <th scope="col w-50">{label.SubModuleName}</th>
                              <th className="text-center" scope="col w-30">{label.AllSelect}</th>
                              <th scope="col w-5">{label.create}</th>
                              <th scope="col w-5">{label.read}</th>
                              <th scope="col w-5">{label.update}</th>
                              <th scope="col w-5">{label.delete}</th>
                            </tr>
                          </thead>
                          <tbody style={{ fontSize: "12px" }}>
                            {allSubModulesList &&
                              allSubModulesList.length > 0 &&
                              allSubModulesList.map((element, index) => {
                                return (
                                  <tr key={index}>
                                    <td>{element.name}</td>
                                    <td className="d-flex justify-content-center align-items-center">
                                      <input
                                        type="checkbox"
                                        // defaultChecked={
                                        //   allAssignedSubModulesList.subModules &&
                                        //     allAssignedSubModulesList.subModules[
                                        //       element.name
                                        //     ]?.filter((el) => el == "C")
                                        //     ? true
                                        //     : false
                                        // }
                                        checked={
                                          selectCheck.find(
                                            (ele) => ele == element.id + "_C"
                                          ) &&
                                            selectCheck.find(
                                              (ele) => ele == element.id + "_R"
                                            ) &&
                                            selectCheck.find(
                                              (ele) => ele == element.id + "_U"
                                            ) &&
                                            selectCheck.find(
                                              (ele) => ele == element.id + "_D"
                                            )
                                            ? true
                                            : false
                                        }
                                        onChange={(event) =>
                                          updateSubModule(
                                            [
                                              element.id + "_C",
                                              element.id + "_R",
                                              element.id + "_U",
                                              element.id + "_D",
                                            ],
                                            element.id,
                                            "All",
                                            allCheckedBox[index],
                                            index
                                          )
                                        }
                                      />{" "}
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        checked={
                                          selectCheck.find(
                                            (ele) => ele == element.id + "_C"
                                          )
                                            ? true
                                            : false
                                        }
                                        onChange={() =>
                                          updateSubModule(
                                            [element.id + "_C"],
                                            element.id,
                                            "C",
                                            allCheckedBox[index],
                                            index
                                          )
                                        }
                                      />{" "}
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        // defaultChecked={
                                        //   allAssignedSubModulesList.subModules &&
                                        //     allAssignedSubModulesList.subModules[
                                        //       element.name
                                        //     ]?.filter((el) => el == "R")
                                        //     ? true
                                        //     : false
                                        // }
                                        checked={
                                          selectCheck.find(
                                            (ele) => ele == element.id + "_R"
                                          )
                                            ? true
                                            : false
                                        }
                                        onChange={() =>
                                          updateSubModule(
                                            [element.id + "_R"],
                                            element.id,
                                            "R",
                                            allCheckedBox[index],
                                            index
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        // defaultChecked={
                                        //   allAssignedSubModulesList.subModules &&
                                        //     allAssignedSubModulesList.subModules[
                                        //       element.name
                                        //     ]?.filter((el) => el == "U")
                                        //     ? true
                                        //     : false
                                        // }
                                        checked={
                                          selectCheck.find(
                                            (ele) => ele == element.id + "_U"
                                          )
                                            ? true
                                            : false
                                        }
                                        onChange={() =>
                                          updateSubModule(
                                            [element.id + "_U"],
                                            element.id,
                                            "U",
                                            allCheckedBox[index],
                                            index
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        // defaultChecked={
                                        //   allAssignedSubModulesList.subModules &&
                                        //     allAssignedSubModulesList.subModules[
                                        //       element.name
                                        //     ]?.filter((el) => el == "D")
                                        //     ? true
                                        //     : false
                                        // }
                                        checked={
                                          selectCheck.find(
                                            (ele) => ele == element.id + "_D"
                                          )
                                            ? true
                                            : false
                                        }
                                        onChange={() =>
                                          updateSubModule(
                                            [element.id + "_D"],
                                            element.id,
                                            "D",
                                            allCheckedBox[index],
                                            index
                                          )
                                        }
                                      />
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )} */}
                </>
              )}

              {selectedType == 2 && (
                <>
                  <div className="row">
                    <div className="form-group col-md-3">
                      <label className="float-left">
                        {label.DEPARTMENT}
                        <span className="errorText">*</span>
                      </label>
                      <div className="input-group">
                        <select
                          className="form-control"
                          name="department1"
                          onChange={(event) => {
                            handleChangeDepartment(event);
                          }}
                          ref={register({ required: true })}
                        >
                          <option key="" value="">
                            Select
                          </option>
                          {allDepartments.map((ele, i) => {
                            return (
                              <option key={i} value={ele.id}>
                                {ele.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      {_.get("department1.type", errors) === "required" && (
                        <p className="errorText">
                          {label.MANDATORY_FIELD_MESSAGE}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-3">
                      <label className="float-left">
                        {label.SelectRoleFrom}
                        <span className="errorText">*</span>
                      </label>
                      <select
                        className="form-control"
                        name="selectedRoleFrom2"
                        disabled={deparmentList ? false : true}
                        ref={register({ required: true })}
                        onChange={(e) => {
                          onRoleFromChange(e.target.value);
                        }}
                      >
                        <option key={0} value="">
                          {label.COMBO_SELECT}
                        </option>
                        {userRolesList &&
                          userRolesList.length > 0 &&
                          userRolesList.map((element, index) => (
                            <option key={index} value={element.id}>
                              {element.name}
                            </option>
                          ))}
                      </select>
                      {_.get("selectedRoleFrom2.type", errors) ===
                        "required" && (
                          <p className="errorText float-left">
                            {label.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                    </div>
                    <div className="form-group col-md-3">
                      <label className="float-left">
                        {label.SelectUserFrom}
                        <span className="errorText">*</span>
                      </label>
                      <select
                        className="form-control"
                        name="selectedUserFrom2"
                        disabled={selectedRoleFrom ? false : true}
                        ref={register({ required: true })}
                        onChange={(e) => {
                          onUserFromChange(e.target.value);
                          setDeparmentActive(true);
                        }}
                      >
                        <option key={0} value="">
                          {label.COMBO_SELECT}
                        </option>
                        {getUserDeptRoles &&
                          getUserDeptRoles.length > 0 &&
                          getUserDeptRoles.map((element, index) => (
                            <option key={index} value={element.id}>
                              {element.firstName} {element.lastName}
                            </option>
                          ))}
                      </select>
                      {_.get("selectedUserFrom2.type", errors) ===
                        "required" && (
                          <p className="errorText float-left">
                            {label.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-md-3">
                      <label className="float-left">
                        {label.DEPARTMENT}
                        <span className="errorText">*</span>
                      </label>
                      <div className="input-group">
                        <select
                          className="form-control"
                          name="department3"
                          disabled={deparmentActive ? false : true}
                          onChange={(event) => {
                            handleChangeDepartment(event);
                            setRoleActive(true);
                          }}
                          ref={register({ required: true })}
                        >
                          <option key="" value="">
                            Select
                          </option>
                          {allDepartments.map((ele, i) => {
                            return (
                              <option key={i} value={ele.id}>
                                {ele.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      {_.get("department3.type", errors) === "required" && (
                        <p className="errorText">
                          {label.MANDATORY_FIELD_MESSAGE}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-3">
                      <label className="float-left">
                        {label.SelectRoleTo}
                        <span className="errorText">*</span>
                      </label>
                      <select
                        className="form-control"
                        name="selectedRoleTo2"
                        disabled={roleActive ? false : true}
                        ref={register({ required: true })}
                        onChange={(e) => {
                          onRoleToChange(e.target.value);
                        }}
                      >
                        <option key={0} value="">
                          {label.COMBO_SELECT}
                        </option>
                        {roleToList &&
                          roleToList.length > 0 &&
                          roleToList.map((element, index) => (
                            <option key={index} value={element.id}>
                              {element.name}
                            </option>
                          ))}
                      </select>
                      {_.get("selectedRoleTo2.type", errors) === "required" && (
                        <p className="errorText float-left">
                          {label.MANDATORY_FIELD_MESSAGE}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-3">
                      <label className="float-left">
                        {label.SelectUserTo}
                        <span className="errorText">*</span>
                      </label>
                      <select
                        className="form-control"
                        name="selectedUserTo2"
                        disabled={selectedRoleTo ? false : true}
                        ref={register({ required: true })}
                        onChange={(e) => {
                          onUserToChange(e.target.value);
                        }}
                      >
                        <option key={0} value="">
                          {label.COMBO_SELECT}
                        </option>
                        {getUserDeptRolesFrom &&
                          getUserDeptRolesFrom.length > 0 &&
                          getUserDeptRolesFrom
                            .filter((ele) => ele.id != selectedUserFrom)
                            .map((element, index) => (
                              <option key={index} value={element.id}>
                                {element.firstName} {element.lastName}
                              </option>
                            ))}
                      </select>
                      {_.get("selectedUserTo2.type", errors) === "required" && (
                        <p className="errorText float-left">
                          {label.MANDATORY_FIELD_MESSAGE}
                        </p>
                      )}
                    </div>

                    {/* <div className="form-group col-md-3">
                    <label className="float-left">
                      Give Access
                      <span className="errorText">*</span>
                    </label>
                    <select
                      className="form-control"
                      name="flgAccess"
                      ref={register({ required: true })}
                      onChange={(e) => {
                        setFlgAccess(e.target.value);
                      }}
                    >
                      <option key={0} value="">
                        {label.COMBO_SELECT}
                      </option>
                      <option key={1} value="1">
                        Yes
                      </option>
                      <option key={2} value="0">
                        No
                      </option>
                    </select>
                    {_.get("flgAccess.type", errors) === "required" && (
                      <p className="errorText float-left">
                        {label.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                  </div> */}
                    {/* <div className="form-group col-md-3">
                    <label className="float-left">
                      Give Access
                    </label>
                    <input
                      type="checkbox"
                      name="flgAccess"
                      onChange={(e) => {
                        setFlgAccess(e.target.checked);
                      }}
                    />
                  </div> */}
                  </div>

                  <div className="row">
                    <div
                     className="form-group col-md-3 bg-light p-3 rounded"
                    >
                      <label className="float-left">{label.GiveAccess}</label>
                      <br />
                      <div className="custom-control custom-switch">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          // defaultChecked={flgAccessStatus}
                          checked={flgAccessStatus}
                          id="customSwitch1"
                          name="flgAccess"
                          onChange={(e) => {
                            setFlgAccessStatus(e.target.checked);
                          }}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customSwitch1"
                        >
                          {flgAccessStatus
                            ? "access given"
                            : "access not given"}
                        </label>
                      </div>
                    </div>
                  </div>
                </>
              )}

              <div className="row">
                <div className="form-group col-md-6">
                  <button
                    type="reset"
                    className="btn btn-secondary mr-2"
                    onClick={() => onCancelButton()}
                  >
                    {label.BUTTON_CANCEL}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={saveButtonFlag}
                    onClick={handleSubmit((e) => {
                      onSubmit(e);
                    })}
                  >
                    {label.BUTTON_SAVE}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AssignAccessToRoleOrUser;
